import {
	MerifyMMarkSvg,
	MerifyWordmarkBetaSvg,
	MerifyWordmarkSvg,
	MerifyMatchWordmarkBetaSvg,
} from 'images'
import React from 'react'
import styled, { css } from 'styled-components'

export const brandingStyles = css`
	svg {
	}
`

const BrandingView = styled.div`
	${brandingStyles}
`

export type BrandingProps = {
	type?: 'me' | 'me-beta' | 'mark' | 'match-beta'
}
export const Branding = ({ type = 'mark' }: BrandingProps) => {
	return (
		<BrandingView>
			{type === 'me' ? (
				<MerifyWordmarkSvg />
			) : type === 'me-beta' ? (
				<MerifyWordmarkBetaSvg />
			) : type === 'match-beta' ? (
				<MerifyMatchWordmarkBetaSvg />
			) : (
				<MerifyMMarkSvg />
			)}
		</BrandingView>
	)
}
